import React, { Component } from 'react';
import { SetComponentLanguage, ApiRequest, generateUuidv4 } from '../../helpers';
import StreamPlayer from './StreamPlayer/StreamPlayer';
import Chat from '../Chat/Chat';
import { withRouter } from 'react-router-dom';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './Stream.css';
import StreamCodeModal from './StreamCodeModal/StreamCodeModal';
import StreamBootedModal from './StreamBootedModal/StreamBootedModal';
import EventDetails from "../EventListing/Event/EventDetails/EventDetails";
import StreamArtistsModal from './StreamArtistsModal/StreamArtistsModal';
import Message from "../Common/Message/Message";
import PropTypes from "prop-types";
import coverTheater from '../../images/cover-theater.jpg';
import posterGeneric from '../../images/poster-generic.jpeg';
import ReactHtmlParser from 'react-html-parser';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Stream extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAdminUser: false,
            isInPatronMode: false,
            activationCode: (this.props.routeProps.match.params.id) ? this.props.routeProps.match.params.id.toLowerCase().replace(/\s/g,'') : "",
            viewerId: null,
            ablyChannel: {},
            fetchedVideoInfos: false,
            isCodeModalOpen: false,
            eventExists: false,
            activeEvent: {},
            client: {},
            urlEventType: '',
            apiEventType: '',
            message: {
                title: '',
                content: '',
                type: ''
            },
            streamConfig: {},
            errorGeneric: false,
            errorInvalidCode: false,
            errorWrongTimeLivestream: false,
            errorWrongTimeVOD: false,
            errorInvalidTicketVOD: false,
            isBootedModalOpen: false,
            isInStreamPlayerMode: false,
            isInRehearsalMode: false,
            is120minBefore: false
        };
    };

    componentDidMount() {
        const params = this.props.routeProps.match.params;
        const viewerId = generateUuidv4();
        const urlEventDateId = new URLSearchParams(window.location.search).get('event_date_id');
        const urlVimeoId = new URLSearchParams(window.location.search).get('vimeoid');
        const urlEventId = new URLSearchParams(window.location.search).get('eventid');
        const urlEventType = new URLSearchParams(window.location.search).get('eventType');
        let isInPatronMode = urlEventDateId === null && urlVimeoId === null && urlEventId === null;

        this.setState({
            viewerId,
            urlEventType,
            isInPatronMode
        }, () => {
            if (isInPatronMode) {
                // has activation code in url
                if(params && params.id) {
                    this.listenToAblyChannel();
                    this.getVideoInfos(false, 0);
                } else {
                    this.toggleCodeModal();
                }
            }
        });
    };

    componentDidUpdate(prevProps) {
        if (!this.state.isInPatronMode && this.props.user !== prevProps.user) {
            const isAdminRole = this.props.user && (this.props.user.role === 'client' || this.props.user.role === 'admin') || this.props.user.role === 'box-office';
            const urlEventDateId = new URLSearchParams(window.location.search).get('event_date_id');
            const urlVimeoId = new URLSearchParams(window.location.search).get('vimeoid');
            const urlEventId = new URLSearchParams(window.location.search).get('eventid');
            const urlIs120minBefore = new URLSearchParams(window.location.search).get('is120minBefore') === 'true';

            // "Stream player" button for logged-in users
            if(urlEventDateId && this.state.isAdminUser === false && isAdminRole) {
                let dateToFetchVideoInfos = urlEventDateId;
                if (this.state.urlEventType === 'scheduled-content' && !urlIs120minBefore) {
                    dateToFetchVideoInfos = new URLSearchParams(window.location.search).get('event_id');
                }
                this.setState({
                    isInStreamPlayerMode: true,
                    isAdminUser: true,
                    is120minBefore: urlIs120minBefore
                }, () => {
                    this.setState({
                        apiEventType: this.getEventTypeApiString(),
                    }, () => {
                        this.listenToAblyChannel();
                        this.getVideoInfos(true, dateToFetchVideoInfos);
                    });
                });
            }

            // Rehearsal video for logged-in users
            // If passing vimeoId + eventId + logged in user, it's a rehearsal video, so enable the video player
            else if (urlVimeoId && urlEventId) {
                this.setState({
                    isInRehearsalMode: true
                }, () => {
                    this.setState({
                        apiEventType: this.getEventTypeApiString(),
                    }, () => {
                        this.listenToAblyChannel();
                        this.getVideoInfos(true, urlEventId);
                    });
                });
            }
        }
    }

    componentWillUnmount() {
        document.body.classList.remove('stream-player-initialized');
    }

    listenToAblyChannel = () => {
        // Listen to channel to change status of seats & subscribe to 'bounce'
        const ablyChannel = (this.state.isInPatronMode)
            ? window.Ably.channels.get(`stream:${this.state.activationCode}`)
            : window.Ably.channels.get(`stream:user:${this.props.user.id}`);
        this.setState({
            ablyChannel
        });
        ablyChannel.subscribe('bounce', (message) => {
            console.log("Ably - bounce event", message);
            // cannot boot itself
            if (message.data.viewer_id !== this.state.viewerId) {
                this.bootUser();
            }
        });
    };

    bootUser = () => {
        this.setState({
            fetchedVideoInfos: false
        }, () => {
            this.clearStreamConfigFromSession();
            if (!this.state.isBootedModalOpen) {
                this.toggleBootedModal();
            }
        });
    };

    refreshIfPatronAndUrlInvalid = (adminRequest, streamConfig) => {
        if (!adminRequest) {
            const urlPatronEventId = new URLSearchParams(window.location.search).get('event_id');
            const validFullUrl = `/stream/${this.state.activationCode}?event_id=${streamConfig.event_id}`;

            // this will refresh the page with the new url
            if (urlPatronEventId === null) {
                this.props.history.push(validFullUrl);
                this.props.history.go(0);
            }
            // this will only update the url without a page refresh
            else {
                this.props.routeProps.history.replace({pathname: validFullUrl});
            }
        }
    };

    clearStreamConfigFromSession = () => {
        sessionStorage.removeItem('streamPageStreamConfig');
    };

    getVideoInfos = async (adminRequest, eventDateId) => {
        try {
            let streamConfig = false;
            let activeEvent = false;
            let client = false;
            let displayErrorMessage = false;

            const streamPageStreamConfig = JSON.parse(sessionStorage.getItem('streamPageStreamConfig')) || {};
            const secondBetweenTwoDate = streamPageStreamConfig.datTimeFetched ? Math.abs((new Date().getTime() - new Date(streamPageStreamConfig.datTimeFetched).getTime()) / 1000) : false;
            const activationCode = sessionStorage.getItem('streamPageStreamConfig') !== null && JSON.parse(sessionStorage.getItem('streamPageStreamConfig')).activationCode !== null
                ? JSON.parse(sessionStorage.getItem('streamPageStreamConfig')).activationCode
                : "";

            if (streamPageStreamConfig !== {} && activationCode !== "" && activationCode === this.state.activationCode  && secondBetweenTwoDate != false && secondBetweenTwoDate < 120) {
                console.log("get infos from session storage");
                streamConfig = JSON.parse(streamPageStreamConfig.stream);

                if (streamPageStreamConfig.event) {
                    activeEvent = JSON.parse(streamPageStreamConfig.event);
                }

                if (streamPageStreamConfig.client) {
                    client = JSON.parse(streamPageStreamConfig.client);
                }
            } else {
                console.log("do not get infos from session storage");
                this.clearStreamConfigFromSession();
            }

            const streamObjSessionStorage = {};

            const streamResponse = streamConfig || await this.fetchStreamInfos(adminRequest, eventDateId);
            console.log('streamResponse: ', streamResponse);
            this.setState({
                streamConfig: streamResponse.data
            });

            if (streamResponse.data.error) {
                displayErrorMessage = true;
                this.displayErrorMessage(streamResponse.data.error);
            } else {
                displayErrorMessage = false;
                this.setState({
                    fetchedVideoInfos: true
                });
                document.body.classList.add('stream-player-initialized');

                // save stream in local storage
                streamObjSessionStorage.stream = JSON.stringify(streamResponse);
                this.refreshIfPatronAndUrlInvalid(adminRequest, streamResponse.data);
            }

            // const activeEventInfoResponse = await this.getActiveEventInfo("28414");
            const activeEventInfoResponse = activeEvent || await this.getActiveEventInfo(streamResponse.data.event_id);
            console.log('active event info response: ', activeEventInfoResponse);
            if(activeEventInfoResponse.data.event){
                this.setMessage('','','');
                let response = activeEventInfoResponse.data.event;

                this.setState({
                    eventExists: true,
                    activeEvent: response
                }, () => {
                    this.props.setStreamEvent(this.state.activeEvent, this.state.streamConfig);
                    // save event in local storage
                    streamObjSessionStorage.event = JSON.stringify(activeEventInfoResponse);
                });
            } else {
                // this.setMessage(window.general_strings.msg.oops, activeEventInfoResponse.data.error.code,'error');
            }

            // get current client info
            let clientId = this.state.activeEvent.client_id;
            const responseCurrentClient = client || await this.getCurrentClient(clientId);
            console.log('Get Current Client: ', responseCurrentClient);
            this.setState({
                client: responseCurrentClient.data.client || {}
            });
            // save client in local storage
            streamObjSessionStorage.client = JSON.stringify(responseCurrentClient);

            // save everything to sessionStorage
            streamObjSessionStorage.activationCode = this.state.activationCode;
            streamObjSessionStorage.datTimeFetched = new Date();

            if (!displayErrorMessage) {
                sessionStorage.setItem("streamPageStreamConfig", JSON.stringify(streamObjSessionStorage));
            }
        } catch (error) {
            console.log(error);
        }
    };

    getActiveEventInfo = async (eventId) => {
        return await ApiRequest(`/events/public/${eventId}`, {
            method: 'GET'
        });
    };

    getCurrentClient = async (clientId = '') => {
        let query;
        if (/^\d+$/.test(clientId)) {
            query = `/clients/${clientId}`;
        } else {
            query = `/clients/url-short-name/${clientId}`;
        }
        return await ApiRequest(query);
    };

    fetchStreamInfos = async (adminRequest, eventDateId) => {
        if (adminRequest) {
            const data = {};
            const apiEventType = this.state.apiEventType;

            data['viewer_id'] = this.state.viewerId;
            data['type'] = apiEventType;

            if (this.state.isInRehearsalMode) {
                data['event_id'] = eventDateId;
            } else {
                if (apiEventType === 'vod') {
                    data['event_date_id'] = eventDateId;
                } else {
                    if (this.state.is120minBefore) {
                        data['event_date_id'] = eventDateId;
                    } else {
                        data['event_id'] = eventDateId;
                    }
                }
            }

            return await ApiRequest(`/box-office/stream/access`, {
                method: 'POST',
                data: data
            });
        } else {
            return await ApiRequest(`/stream/access`, {
                method: 'POST',
                data: {
                    activation_code: this.state.activationCode,
                    viewer_id: this.state.viewerId
                }
            });
        }
    };

    getEventTypeApiString = () => {
        let eventTypeApiString = '';
        if (this.state.urlEventType === 'video-on-demand') {
            eventTypeApiString = 'vod';
        } else if (this.state.urlEventType === 'live-stream' && this.state.isInRehearsalMode) {
            eventTypeApiString = 'stream-rehearsal';
        } else if (this.state.urlEventType === 'live-stream' && !this.state.isInRehearsalMode) {
            eventTypeApiString = 'live-stream';
        } else if (this.state.urlEventType === 'scheduled-content' && this.state.is120minBefore) {
            eventTypeApiString = 'scheduled-stream';
        } else if (this.state.urlEventType === 'scheduled-content' && !this.state.is120minBefore) {
            eventTypeApiString = 'scheduled-upload';
        }
        return eventTypeApiString;
    };

    displayErrorMessage = (error) => {
        let errorKey = "errorGeneric";
        if (error.code === "stream-event-date-wrong-time") {
            errorKey = "errorWrongTimeLivestream";
        } else if (error.code === "vod-event-date-wrong-time") {
            errorKey = "errorWrongTimeVOD";
        } else if (error.code === "vod-invalid-ticket-redemption") {
            errorKey = "errorInvalidTicketVOD";
        } else if (error.code === "invalid-activation-code") {
            errorKey = "errorInvalidCode";
        }

        this.setState({
            [errorKey]: true
        });
    };

    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    };

    /////* code modal stuff */
    toggleCodeModal = () => {
        this.setState({
            isCodeModalOpen: !this.state.isCodeModalOpen
        });
    };

    toggleBootedModal = () => {
        this.setState({
            isBootedModalOpen: !this.state.isBootedModalOpen
        });
    };

    refreshPageAfterBooted = () => {
        this.props.history.push('/stream');
        this.props.history.go(0);
    };

    saveStreamCode = (activationCode) => {
        this.setState({
            activationCode: activationCode.toLowerCase().replace(/\s/g,'')
        }, () => {
            this.listenToAblyChannel();
            this.getVideoInfos(false, 0);
            this.toggleCodeModal();
            // scroll to top of page
            window.scrollTo(0, 0);
        });
    };

    render() {
        const hasTitleInfos = this.state.client.client_name && this.state.activeEvent.name;
        return (
            <React.Fragment>
                {this.state.message.content !== '' &&
                    <div className="showtix-section">
                        <div className="container">
                            <Message
                                message={this.state.message}
                            />
                        </div>
                    </div>
                }
                <div className="showtix-stream">
                    <StreamCodeModal
                        isCodeModalOpen={this.state.isCodeModalOpen}
                        toggleCodeModal={this.toggleCodeModal}
                        saveStreamCode={this.saveStreamCode}
                    />
                    <StreamBootedModal
                        isBootedModalOpen={this.state.isBootedModalOpen}
                        toggleBootedModal={this.toggleBootedModal}
                        refreshPageAfterBooted={this.refreshPageAfterBooted}
                    />
                    { this.state.eventExists &&
                        <EventDetails
                            event={this.state.activeEvent}
                            client_name={this.state.client.client_name}
                            isInStreamPage={true}
                            isStreamDescriptionModalOpen={this.props.isStreamDescriptionModalOpen}
                            hideStreamDescriptionModal={this.props.hideStreamDescriptionModal}
                        />
                    }
                    <StreamArtistsModal
                        isStreamArtistsModalOpen={this.props.isStreamArtistsModalOpen}
                        toggleStreamArtistsModal={this.props.toggleStreamArtistsModal}
                        activeEvent={this.state.activeEvent}
                    />
                    <div className={this.props.isChatOpen ? 'showtix-section showtix-stream__wrapper chat-is-active' : 'showtix-section showtix-stream__wrapper'} style={{backgroundImage: "url(" + coverTheater + ")"}}>
                        <div className="container showtix-stream__content">
                            <div className="row mb-4">
                                <div className="showtix-stream__content__inner">
                                    <React.Fragment>
                                        { this.state.fetchedVideoInfos
                                            ?
                                            <React.Fragment>
                                                <StreamPlayer
                                                    activationCode={this.state.activationCode}
                                                    videoType={this.state.apiEventType}
                                                    streamConfig={this.state.streamConfig}
                                                ></StreamPlayer>
                                                <Chat
                                                    isChatOpen={this.props.isChatOpen}
                                                    streamEvent={this.state.streamEvent}
                                                    streamConfig={this.state.streamConfig}
                                                    toggleChat={this.toggleChat}
                                                />
                                            </React.Fragment>
                                            :
                                            <React.Fragment>
                                                <div className="showtix-stream__placeholder" style={{backgroundImage: "url(" + posterGeneric + ")"}}>
                                                    <div className="showtix-stream__placeholder__overlay"></div>
                                                    { this.state.errorGeneric &&
                                                        <p className="showtix-stream__placeholder__error">{ReactHtmlParser(strings.errorGeneric)}</p>
                                                    }
                                                    { this.state.errorInvalidCode &&
                                                        <p className="showtix-stream__placeholder__error">{ReactHtmlParser(strings.errorInvalidCode)}</p>
                                                    }
                                                    { this.state.errorWrongTimeLivestream &&
                                                        <p className="showtix-stream__placeholder__error">{ReactHtmlParser(strings.errorWrongTimeLivestream)}</p>
                                                    }
                                                    { this.state.errorWrongTimeVOD &&
                                                        <p className="showtix-stream__placeholder__error">{ReactHtmlParser(strings.errorWrongTimeVOD)}</p>
                                                    }
                                                    { this.state.errorInvalidTicketVOD &&
                                                    <p className="showtix-stream__placeholder__error">{ReactHtmlParser(strings.errorInvalidTicketVOD)}</p>
                                                    }
                                                </div>
                                            </React.Fragment>
                                        }
                                    </React.Fragment>
                                </div>
                                <div className="col-12 text-center">
                                    <h2 className="showtix-stream__title">
                                        { hasTitleInfos
                                            ?
                                            <span>
                                                {ReactHtmlParser(this.state.client.client_name)} {strings.title} {ReactHtmlParser(this.state.activeEvent.name)}
                                            </span>
                                            : <span>&nbsp;</span>
                                        }
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <style dangerouslySetInnerHTML={{__html: `
                        .stream-player-initialized .zopim {
                            display: none !important;
                        }
                    `}} />
                </div>
            </React.Fragment>
        );
    }
}

Stream.propTypes = {
    user: PropTypes.object,
    setStreamEvent: PropTypes.func,
    isStreamDescriptionModalOpen: PropTypes.bool,
    toggleStreamDescriptionModal: PropTypes.func,
    hideStreamDescriptionModal: PropTypes.func,
    isStreamArtistsModalOpen: PropTypes.bool,
    toggleStreamArtistsModal: PropTypes.func,
};

export default withRouter(Stream);



// WEBPACK FOOTER //
// ./src/components/Stream/Stream.js